import { mapState } from 'vuex'
import {
  apiGetPostCodes,
  apiGetPostalChartsData,
  apiGetPostalTableData,
  apiGetReportBlob
} from '@/services/API/chart'

import { apiGetAdminUserCompanies } from '@/services/API/admin'
import { USER_MODULE_NAME } from '@/store/types'
import maLoader from '@/components/loaderSmall'
import maPaginator from '@/components/paginator'
import maMapPostCodes from './components/map'
import maChartBar from './components/chartBar'
import maChartBarAverage from './components/chartBarAverage'
import maChartTable from './components/chartTable'
import maDataFilter from './components/dataFilter'
import maChartPie from './components/chartPie'
import maModal from '@/components/modal'

export default {
  name: 'charts',
  components: {
    maMapPostCodes,
    maChartBar,
    maChartBarAverage,
    maChartTable,
    maDataFilter,
    maChartPie,
    maLoader,
    maPaginator,
    maModal
  },
  data () {
    return {
      selectedPostCode: null,
      dataFilters: [],
      dataAllCharts: [],
      dataTable: [],
      idCompany: null,
      dataAllPostCodes: [],
      selectedOptionFilter: null,
      keyFilter: 0,
      keyEvolutionBar: 0,
      currentPage: 1,
      totalPages: 0,
      allDataTable: [],
      amountTableElements: 20,
      totalTableElements: 0,
      keyTable: 0,
      keyBarChart: 0,
      idFilterWarranty: 0,
      idFilterSubWarranty: 0,
      filtersObj: {},
      fromDateFilter: null,
      toDateFilter: null,
      hintSelectToDate: false,
      hintSelectFromDate: false
    }
  },
  computed: {
    ...mapState(USER_MODULE_NAME, {
      stateUserIsSuperAdmin: 'isSuperAdmin'
    }),
    tableText () {
      const localeDate = `${this.$i18n.locale}-${this.$i18n.locale.toUpperCase()}`
      const currentDate = new Date()
      const currentMonth = currentDate.toLocaleString(localeDate, { month: 'long' }).toUpperCase()
      const currentYear = currentDate.getFullYear()
      const postCode = this.selectedPostCode ? this.selectedPostCode : ''
      const currentFullDate = postCode + ' ' + currentMonth + ' ' + currentYear
      const selectedFromDate = new Date(this.fromDateFilter).toLocaleString(localeDate, { month: 'long', day: 'numeric', year: 'numeric' }).toUpperCase()
      const selectedToDate = new Date(this.toDateFilter).toLocaleString(localeDate, { month: 'long', day: 'numeric', year: 'numeric' }).toUpperCase()
      if (this.fromDateFilter && this.toDateFilter) {
        return postCode + ' - ' + selectedFromDate + ' - ' + selectedToDate
      } else {
        return currentFullDate
      }
    },
    zipCodeDisplay () {
      return this.$t('warrantyProps.zipCode.literal') + ': ' + (this.selectedPostCode ? this.selectedPostCode : this.$t('common.noSelected'))
    }
  },
  methods: {
    handleClickPreviousPage (page) {
      if (page > 0) {
        this.totalTableElements -= this.amountTableElements
        this.currentPage = page
        this.dataTable.tableRows = []
        this.dataTable.tableRows = this.allDataTable.slice(this.totalTableElements, this.totalTableElements + this.amountTableElements)
        this.keyTable++
      }
    },
    handleClickNextPage (page) {
      if (page <= this.totalPages) {
        this.totalTableElements += this.amountTableElements
        this.currentPage = page
        this.dataTable.tableRows = []
        this.dataTable.tableRows = this.allDataTable.slice(this.totalTableElements, this.totalTableElements + this.amountTableElements)
        this.keyTable++
      }
    },
    handlePageSet (page) {
      this.currentPage = page
    },
    handleMarkerClick (postCode) {
      this.selectedPostCode = postCode
      this.filtersConditions()
    },
    handleGetMapData () {
      apiGetPostalTableData(this.filtersObj).then((res) => {
        this.allDataTable = res
        this.dataTable.tableRows = this.allDataTable.slice(0, this.amountTableElements)
        const totalPagesCount = this.totalPages = parseInt(res.length) / parseInt(this
          .amountTableElements)
        this.totalPages = Math.round(totalPagesCount) > 0 ? Math.round(totalPagesCount) : 1
      })
      apiGetPostalChartsData(this.filtersObj).then(res => {
        this.dataAllCharts = []
        this.dataAllCharts = res
        this.keyEvolutionBar++
        this.keyBarChart++
      })
    },
    handleFilterCompany (id) {
      this.idCompany = parseInt(id)
      this.filtersConditions()
    },
    getDataCharts (dataObject) {
      apiGetPostalTableData(dataObject).then((res) => {
        this.allDataTable = res
        const tableRowsData = this.allDataTable.slice(0, this.amountTableElements)
        const totalPagesCount = this.totalPages = parseInt(res.length) / parseInt(this
          .amountTableElements)
        this.totalPages = this.totalPages = Math.round(totalPagesCount) > 0 ? Math.round(totalPagesCount) : 1

        this.dataTable = {
          'tableHead':
            [
              this.$t('charts.tableHeadTitle.company'),
              this.$t('charts.tableHeadTitle.userName'),
              this.$t('charts.tableHeadTitle.l1'),
              this.$t('charts.tableHeadTitle.l2'),
              this.$t('charts.tableHeadTitle.l3'),
              this.$t('charts.tableHeadTitle.l4'),
              this.$t('charts.tableHeadTitle.q'),
              this.$t('charts.tableHeadTitle.averageCost'),
              this.$t('charts.tableHeadTitle.total')
            ],
          'tableRows': tableRowsData
        }
      })
      if (!this.selectedPostCode) {
        apiGetPostCodes(dataObject).then(res => {
          this.dataAllPostCodes = res
        })
      }
      apiGetPostalChartsData(dataObject).then(res => {
        this.dataAllCharts = res
        this.keyEvolutionBar++
        this.keyBarChart++
      })
    },
    handleFilterWarranty (filterWarranty) {
      this.idFilterWarranty = parseInt(filterWarranty.warranty)
      const noOptionSelected = 0
      if (this.idFilterWarranty === noOptionSelected) {
        this.selectedOptionFilter = this.$t('common.noSelected')
      }
      this.idFilterSubWarranty = noOptionSelected
      this.$emit('filterSubwarranty:noSelectedOtion')
      this.filtersConditions()
    },
    handleFilterSubWarranty (filterSubWarranty) {
      this.idFilterSubWarranty = parseInt(filterSubWarranty.subwarranty)
      this.filtersConditions()
    },
    filtersConditions () {
      this.filtersObj = {}

      if (this.selectedPostCode) {
        this.filtersObj['postal_code'] = this.selectedPostCode.toString()
      }

      if (this.fromDateFilter && this.toDateFilter) {
        this.filtersObj['from_date'] = this.fromDateFilter
        this.filtersObj['to_date'] = this.toDateFilter
      } else if (!this.fromDateFilter && !this.toDateFilter && this.filtersObj.from_date && this.filtersObj.to_date) {
        delete this.filtersObj.from_date
        delete this.filtersObj.to_date
      }

      if (this.idCompany > 0 && this.idFilterWarranty === 0) {
        this.filtersObj['id_company'] = this.idCompany
      } else if (this.idCompany === 0 && this.idFilterWarranty > 0 && this.idFilterSubWarranty === 0) {
        this.filtersObj['warranty_id'] = this.idFilterWarranty
      } else if (this.idCompany === 0 && this.idFilterWarranty > 0 && this.idFilterSubWarranty > 0) {
        this.filtersObj['warranty_id'] = this.idFilterWarranty
        this.filtersObj['warranty_subtype_id'] = this.idFilterSubWarranty
      } else if (this.idCompany > 0 && this.idFilterWarranty > 0 && this.idFilterSubWarranty > 0) {
        this.filtersObj['id_company'] = this.idCompany
        this.filtersObj['warranty_id'] = this.idFilterWarranty
        this.filtersObj['warranty_subtype_id'] = this.idFilterSubWarranty
      } else if (this.idFilterSubWarranty === 0 && this.idFilterWarranty > 0 && this.idCompany > 0) {
        this.filtersObj['id_company'] = this.idCompany
        this.filtersObj['warranty_id'] = this.idFilterWarranty
      } else if (this.idFilterSubWarranty === 0 && this.idFilterWarranty === 0 && this.idCompany > 0) {
        this.filtersObj['id_company'] = this.idCompany
      } else if (this.idFilterSubWarranty === 0 && this.idFilterWarranty === 0 && this.idCompany === 0 && !this.selectedPostCode && !this.fromDateFilter && !this.toDateFilter) {
        this.getDataCharts()
      }

      if (Object.keys(this.filtersObj).length > 0) {
        this.getDataCharts(this.filtersObj)
      }
    },
    handleDateFromFilterChange (fromDateValue) {
      this.fromDateFilter = fromDateValue
      this.showHintsFilterDates()

      if (!this.fromDateFilter || !this.toDateFilter) return

      if (this.fromDateFilter && this.toDateFilter) {
        this.filtersConditions()
      } else if (!this.fromDateFilter && !this.toDateFilter) {
        this.filtersConditions()
      }
    },
    showHintsFilterDates () {
      if (!this.toDateFilter && !this.fromDateFilter) {
        this.hintSelectToDate = true
        this.hintSelectFromDate = true
      } else if (!this.fromDateFilter) {
        this.hintSelectFromDate = true
      } else if (!this.toDateFilter) {
        this.hintSelectToDate = true
      }
      setTimeout(() => {
        this.hintSelectToDate = false
        this.hintSelectFromDate = false
      }, 1500)
    },
    handleDateToFilterChange (toDateValue) {
      this.toDateFilter = toDateValue
      this.showHintsFilterDates()

      if (!this.fromDateFilter || !this.toDateFilter) return

      if (this.fromDateFilter && this.toDateFilter) {
        this.filtersConditions()
      } else if (!this.fromDateFilter && !this.toDateFilter) {
        this.filtersConditions()
      }
    },
    getCompanyData () {
      return apiGetAdminUserCompanies().then(dataCompanies => {
        this.dataFilters = dataCompanies
      })
    },
    handleClickDownloadData () {
      this.$refs.downloadModal.showModal = true
      const fileName = 'MAVALUE data report.xlsx'
      const mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      apiGetReportBlob(fileName, this.filtersObj, mimeType)
    },
    async handleGetDataCharts () {
      this.filtersObj = {}
      if (this.stateUserIsSuperAdmin) {
        this.selectedPostCode = null
        this.getDataCharts()
        await this.getCompanyData()
        this.dataFilters.push({
          'key': 0,
          'literal': this.$t('common.noSelected')
        })
        this.dataFilters.sort((a, b) => a.key - b.key)
        this.selectedOptionFilter = this.$t('common.noSelected')
        this.idFilterSubWarranty = 0
        this.fromDateFilter = null
        this.toDateFilter = null
        this.idFilterWarranty = 0
        this.idCompany = 0
        this.keyFilter++
      } else {
        await this.getCompanyData()
        const targetCompany = this.dataFilters[0]
        this.selectedPostCode = null
        this.idFilterSubWarranty = 0
        this.idFilterWarranty = 0
        this.fromDateFilter = null
        this.toDateFilter = null
        this.idCompany = 0
        this.keyFilter++
        this.handleFilterCompany(targetCompany.key)
        this.selectedOptionFilter = targetCompany.key
      }
    }
  },
  mounted () {
    this.handleGetDataCharts()
  }

}
